// import React from "react";
// import { Row, Col, Typography, Tooltip, Progress, Steps } from "antd";
// import ConsumerApplicationProgressBar from "../views/ConsumerProject/Consumer/ConsumerApplicationProgressBar";
// import ConsumerShowApplicationId from "../views/ConsumerProject/Consumer/ConsumerShowApplicationId";
// import "./ApplicationHeader.css";
// import "./LoanApplicationStepper.css";

// const { Step } = Steps;
// const { Title, Text } = Typography;


// const LoanApplicationStepper = ({ currentStep = 0, showProgress = false, progressPercent = 0, showApplicationId = false }) => {
//     return (
//         <Row gutter={[16, 16]} className="loan-stepper-wrapper" align="middle" style={{ marginLeft: '0px', marginRight: '0px' }}>
//             <Col xs={24} sm={24} md={showProgress || showApplicationId ? 17 : 24} lg={showProgress || showApplicationId ? 17 : 24} xl={showProgress || showApplicationId ? 18 : 24}>
//                 {/* <Steps
//                 current={currentStep}
//                 responsive
//                 className="custom-steps"
//             >
//                 <Step title={<span className="step-title-wrapper">New Liquidity<br/>Application</span>} />
//                 <Step title={<span className="step-title-wrapper">Document<br/>Upload</span>} />
//                 <Step title={<span className="step-title-wrapper">Uploaded<br/>Documents</span>} />
//             </Steps> */}
//                 <Steps
//                     current={currentStep}
//                     className="loan-custom-steps"
//                 >
//                     <Step title="Initial Inputs" />
//                     <Step title="Document Upload" />
//                     <Step title="Review & Submit" />
//                 </Steps>

//             </Col>

//             {(showProgress || showApplicationId) && (
//                 <Col xs={24} sm={24} md={6} lg={6} xl={6}>
//                     {showProgress ? (
//                         <div className="stepper-info-section">
//                             <Text type="secondary" className="stepper-info-label">
//                                 Application Progress
//                             </Text>
//                             <Tooltip title={`Application Workflow Progress: ${progressPercent}%`}>
//                                 <ConsumerApplicationProgressBar />
//                             </Tooltip>
//                         </div>
//                     ) : showApplicationId ? (
//                         <div className="stepper-info-section">
//                             <Title level={5} className="stepper-app-id">
//                                 <ConsumerShowApplicationId />
//                             </Title>
//                             <ConsumerApplicationProgressBar />
//                         </div>
//                     ) : null}
//                 </Col>
//             )}
//         </Row>
//     );
// };

// export default LoanApplicationStepper;


// import React from "react";
// import { Row, Col, Typography, Tooltip, Steps } from "antd";
// import ConsumerApplicationProgressBar from "../views/ConsumerProject/Consumer/ConsumerApplicationProgressBar";
// import ConsumerShowApplicationId from "../views/ConsumerProject/Consumer/ConsumerShowApplicationId";
// import "./ApplicationHeader.css";
// import "./LoanApplicationStepper.css";

// const { Step } = Steps;
// const { Title, Text } = Typography;

// const LoanApplicationStepper = ({
//     currentStep = 0,
//     showProgress = false,
//     progressPercent = 0,
//     showApplicationId = false,
// }) => {
//     return (
//         <Row
//             gutter={[16, 16]}
//             className="loan-stepper-wrapper"
//             align="middle"
//             style={{ marginLeft: 0, marginRight: 0 }}
//         >
//             <div className="steps-center-wrapper">
//                 <Steps
//                     current={currentStep}
//                     className="loan-custom-steps"
//                 >
//                     <Step title="Initial Inputs" />
//                     <Step title="Document Upload" />
//                     <Step title="Review & Submit" />
//                 </Steps>
//             </div>
//         </Row>
//     );
// };

// export default LoanApplicationStepper;


import React from "react";
import { Row, Steps } from "antd";
import "./LoanApplicationStepper.css";

const { Step } = Steps;

const LoanApplicationStepper = ({ currentStep = 0 }) => {
    return (
        <Row className="loan-stepper-wrapper" justify="center">
            <div className="steps-center-wrapper">
                <Steps
                    current={currentStep}
                    labelPlacement="vertical" // Key for your design
                    className="loan-custom-steps"
                >
                    <Step title="Client Inputs" />
                    <Step title="Diligence Upload" />
                    <Step title="Review & Submit" />
                </Steps>
            </div>
        </Row>
    );
};

export default LoanApplicationStepper;